import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostDateiHochladenCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostDateiHochladenCommandService],
  exports: []
})
export class PostDateiHochladenCommandServiceModule { }
